import React, { useEffect, useState, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { useAdminCurrentUser } from "data/admin/user";
import { UsersApi } from "data/api";
import { call } from "data/api/rest";
import { useTranslation } from "react-i18next";

const TermsConsent: React.FC = () => {
  const [t] = useTranslation()
  const [{ user }] = useAdminCurrentUser();
  const [showPrivacyConsent, setShowPrivacyConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  //mount and check if the user.agreedTncDate value
  useEffect(() => {
    setShowPrivacyConsent(!!user && user?.agreedTncDate == null);
  }, [user]);

  const handleAccept = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const res = await call(UsersApi).apiV1UsersAgreeTncPost();
      const updatedUser = res?.data;
      const ok = res?.error == null && !!updatedUser;
      if (ok) {
        setShowPrivacyConsent(false);
      }
      else {
        setError(t("common.error.somethingWrong"));
      }
    }
    catch (e) {
      setError(t("common.error.somethingWrong"));
    }
    finally {
      setSubmitting(false);
    }
  };

  if (!showPrivacyConsent) return null;

  return (
    <Dialog
      open={showPrivacyConsent}
      fullWidth
      BackdropProps={{
        style: { backdropFilter: "blur(4px)" },
      }}
    >
      <DialogTitle>{t("termsConsent.title")}</DialogTitle>
      <DialogContent>
        <Typography color="textPrimary">
          {t("termsConsent.message")}
        </Typography>
        <Typography color="primary">
          <Link
            href="https://www.us.endress.com/en/Terms-of-use"
            target="_blank" rel="noopener noreferrer" style={{ cursor: "pointer" }}>{t("termsConsent.viewTerms")}</Link>
        </Typography>
      </DialogContent>
      <DialogActions>
        {error && <Typography color="error" style={{ marginRight: 8 }}>{error}</Typography>}
        {/* <Button variant="contained" color="primary" onClick={handleAccept}>
          Accept
        </Button> */}
        <Button variant="contained" color="primary" onClick={handleAccept} disabled={submitting}>
          {submitting ? t("termsConsent.acceptingBtn") : t("termsConsent.acceptBtn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsConsent;